export default __webpack_public_path__ + "static/media/mtiLogoBottomAligned.e03143b3.png";